import { useEffect, useState } from 'react';
import { session } from '@/lib/session';
import type { CurrentUser } from '@/types/auth';

/**
 * Subscribes to the active session and exposes the current user. Returns
 * `null` while logged out. Components should not assume non-null — wrap
 * gates with `<RequireAuth>` instead.
 */
export function useCurrentUser(): CurrentUser | null {
  const [user, setUser] = useState<CurrentUser | null>(() => session.cachedUser());

  useEffect(() => {
    return session.subscribe((s) => {
      setUser(s?.user ?? session.cachedUser());
    });
  }, []);

  return user;
}
